import { debounce } from 'lodash';
import React, { useCallback, useRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { actions as medicationsActions } from '../../../redux/appointmentForm/requests/medications-req';
import { selectMedicationSearchData } from '../../../redux/appointmentForm/selectors';
import { targetUserSelector } from '../../../redux/context/selectors';
import SelectCustom from '../../SelectCustom';

const MedicationSelect = ({
  handleBlur,
  onChange,
  onCheckBeforeDelete,
  label,
  value,
  placeholder,
}) => {
  const offsetRef = useRef(0);
  const dispatch = useDispatch();
  const [medicationQuery, setMedicationQuery] = useState('');
  const profile = useSelector(targetUserSelector);
  const medicationList = useSelector(selectMedicationSearchData);

  const handleMedicationsSearch = debounce(text => {
    offsetRef.current = 0;
    dispatch(medicationsActions.clear());

    if (text.length < 3) return;
    setMedicationQuery(text);
    dispatch(
      medicationsActions.send({
        userId: profile.id,
        limit: 10,
        query: text,
        offset: offsetRef.current,
      }),
    );
  }, 1000);

  const loadMore = useCallback(
    debounce(() => {
      dispatch(
        medicationsActions.loadMore({
          userId: profile.id,
          query: medicationQuery,
          offset: offsetRef.current,
        }),
      );
      offsetRef.current += 10;
    }, 100),
    [profile.id, medicationQuery],
  );

  const renderMedicationSearch = useMemo(
    () => (
      <SelectCustom
        multi
        options={medicationList}
        placeholder={placeholder}
        label={label}
        defaultValue={value}
        onMenuScrollToBottom={loadMore}
        onInputChange={handleMedicationsSearch}
        onCheckBeforeDelete={onCheckBeforeDelete}
        onChange={onChange}
        onBlur={handleBlur}
      />
    ),
    [value, medicationList.length],
  );

  return <React.Fragment>{renderMedicationSearch}</React.Fragment>;
};

MedicationSelect.propTypes = {
  handleBlur: PropTypes.func,
  onChange: PropTypes.func,
  onCheckBeforeDelete: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.array,
};

export default MedicationSelect;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/MedicationSelect/index.jsx